import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { useCartContext } from "../context";
import { Navigate } from "react-router-dom";
import { useAuthContext } from "../authContext";
import Cart from "../cart/Cart";
import "./header.css";
import MessageContainer from "../messageContainer/MessageContainer";
import { noItemInCart,loginSuccess } from "../data/data";
const logo =
  "https://banner2.cleanpng.com/20180930/kfo/kisspng-design-e-commerce-service-food-company-amazon-com-filtr-deals-pro-appstore-for-android-5bb131f15e1464.3695653615383393133854.jpg";

const Header = ({ selectedCategory, setSelectedCategory }) => {
  //to manage data fetched from api efficiently
  const [data, setData] = useState([]);

  const [showpopup, setShowPopup] = useState(false);

  const [popupLoginSuccess, setPopupLoginSuccess] = useState(false);

  const { cart } = useCartContext();

  const {isAuthenticated, userExists, logout } = useAuthContext();

  const totalQuantity = Object.values(cart).reduce((total, product) => {
    return total + product.quantity;
  }, 0);

  const total = () => {
    let count = 0;
    for (let item in cart) {
      count += cart[item].quantity;
    }
    return count;
  };

  //to store ui update for cart open change
  const [openCart, setOpenCart] = useState(false);

  useEffect(() => {
    fetch("https://fakestoreapi.com/products/categories")
      .then((response) => response.json())
      .then((json) => {
        setData(json);
      });
  }, []);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };
  // const handlepopup = useCallback(() => {
  //   setShowPopup(true);
  // }, []);

  useEffect(() => {
    if (isAuthenticated) setPopupLoginSuccess(true);
    else setPopupLoginSuccess(false);
  }, [isAuthenticated]);

  useEffect(() => {
    const timeoutIdLoginSuccess = setTimeout(() => {
      setPopupLoginSuccess(false);
    }, 3000);
    return () => clearTimeout(timeoutIdLoginSuccess);
  }, [popupLoginSuccess]);


  useEffect(() => {
    const timeoutIdNoProduct = setTimeout(() => {
      setShowPopup(false);
    }, 5000);
    return () => clearTimeout(timeoutIdNoProduct);
  }, [showpopup]);

  function handleLogoClick() {
    window.scrollTo(0, 0);
    <Navigate to="/home" />;
  }

  function handleCartClick() {
    if (totalQuantity === 0) setShowPopup(true);
    setOpenCart(!openCart);
  }

  function handleLogOut() {
    logout();
  }

  return (
    <div className="header">
      <div
        onClick={() => {
          handleLogoClick();
        }}
        className="header-logo"
      >
        <img src={logo} alt="E-Com App Logo" />
      </div>

      <ul className="header-categories">
        {data.map((category) => {
          return (
            <li
              onClick={() => handleCategoryClick(category)}
              className={
                "category-item " +
                (category === selectedCategory ? "category-item--selected" : "")
              }
              key={category}
            >
              {category}
            </li>
          );
        })}
      </ul>
      <div className="shopping-cart">
        <FontAwesomeIcon
          onClick={() => handleCartClick()}
          className={"cart-icon "}
          icon={faShoppingCart}
        />
        <span className="cart-length">{total()}</span>
      </div>

      {totalQuantity===0?null: <Cart openCart={openCart} />}

      {userExists ? (
        <button className="logout-button" type="button" onClick={handleLogOut}>
          Logout
        </button>
      ) : null}

      {/* <button
        type="button"
        style={{ position: "absolute", top: "10vh", left: "40vw" }}
        onClick={handlepopup}
      >
        Show Popup
      </button> */}
      {showpopup ? <MessageContainer data={noItemInCart} /> : null}
      {popupLoginSuccess ? <MessageContainer data={loginSuccess} /> : null}
    </div>
  );
};

export default Header;
